import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {UserRequest} from '../services/rest_users';
import {IUsers} from '../types/users';
import {Utils} from '../utils';

interface IUsersState {
  usersData: Array<IUsers>,
  userInfoData: Array<IUsers>
  auth: boolean,
  token: string
}

const initialState: IUsersState = {
  usersData: [],
  userInfoData: [],
  auth: false,
  token: ''
};
export const Registration: any = createAsyncThunk(
  'Users',
  async (payload: []) => {
      return await UserRequest.registration(payload);
  },
);
export const Login = createAsyncThunk(
  'Users',
  async (payload: []) => {
    return await UserRequest.login(payload);
  },
);
export const resetPassword = createAsyncThunk(
  'resetPassword',
  async (email: string) => {
    return await UserRequest.resetPassword(email);
  },
);
export const UserInfo: any = createAsyncThunk(
  'UserInfo',
  async (payload: {}) => {
    return await UserRequest.userInfo(payload);
  },
);

export const resetNewPassword: any = createAsyncThunk(
    'resetNewPassword',
    async (payload: {pass: string, token: string}) => {
        return await UserRequest.resetNewPassword(payload);
    },
);

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setAuth(state, action) {
      state.auth = action.payload;
    },
    setUserInfo(state, action) {
      state.token = action.payload
      state.userInfoData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(UserInfo.fulfilled, (state, action) => {
      state.userInfoData = Utils.decrypt(action.payload);
    });
  },
});
export default usersSlice.reducer;
export const { setAuth,setUserInfo } = usersSlice.actions;
